import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SettingsService = /** @class */ (function () {
    /**
    * Creates an instance of SettingsService.
    * @param {HttpClient} httpClient
    * @memberof SettingsService
    */
    function SettingsService(httpClient) {
        this.httpClient = httpClient;
    }
    /**
    * Methode is part of Bootflow in app.module.ts
    */
    SettingsService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadSettings()];
                    case 1:
                        _a.sent();
                        this.checkIntegrity();
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsService.prototype.loadSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.httpClient.get('settings/settings.json').toPromise()];
                    case 1:
                        _a.settings = (_b.sent());
                        return [2 /*return*/];
                }
            });
        });
    };
    SettingsService.prototype.checkIntegrity = function () {
        // Test if there are duplicate domain names in the settings
        if (this.hasDuplicates(this.settings.frontend.domains.map(function (domain) { return domain.name; }))) {
            console.warn('Duplicate domain name(s) in settings');
        }
        // Test if there are duplicate domain uris in the settings
        if (this.hasDuplicates(this.settings.frontend.domains.map(function (domain) { return domain.uri; }))) {
            console.warn('Duplicate domain uri(s) in settings');
        }
    };
    SettingsService.prototype.hasDuplicates = function (items) {
        return items.length !== items.filter(function (item, index) { return items.indexOf(item) === index; }).length;
    };
    SettingsService.ngInjectableDef = i0.defineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(i0.inject(i1.HttpClient)); }, token: SettingsService, providedIn: "root" });
    return SettingsService;
}());
export { SettingsService };
